import {Base, model, belongsTo, endpoint} from '@scoutgg/ftw/source/lib/model'
import setTo from '@scoutgg/ftw/source/decorators/set-to'

const matchPrices = Symbol('matchPrices')

@model('Price')
@endpoint('prices', {root: '/api'})
@belongsTo('season')
@belongsTo('player')
@setTo('remarks', [
  'line',
  'ppLine',
  'weightClass',
  'role',
  'quater',
])
export class Price extends Base {
  set prices(v) {}
  get prices() {
    if(!this.matchPrices) this.matchPrices = {}
    return this.matchPrices
  }

  set matchPrices(v) {
    if(!this[matchPrices]) {
      this[matchPrices] = v
    } else {
      Object.assign(this[matchPrices], v)
    }
  }

  get matchPrices() {
    return this[matchPrices]
  }

  toJSON() {
    return Object.assign(super.toJSON(), {
      matchPrices: this.matchPrices,
    })
  }
}
